import { InvoiceStatus, UserRequestStatus, SelectOption } from '@/shared/types';

import type { StatusDecorator } from './common';

export enum PaymentDetailsFieldName {
  price = 'price',
  fee = 'fee',
  receiver = 'receiver',
  edrpou = 'edrpou',
  iban = 'iban',
  purpose = 'purpose',
  isPayable = 'isPayable',
  payData = 'payData',
}

export interface AdditionalPayDataItem {
  amount: number;
  info: string;
}

export type ResponsePaymentDetails = {
  [PaymentDetailsFieldName.price]: number;
  [PaymentDetailsFieldName.fee]: number;
  [PaymentDetailsFieldName.receiver]: string;
  [PaymentDetailsFieldName.edrpou]: string;
  [PaymentDetailsFieldName.iban]: string;
  [PaymentDetailsFieldName.purpose]: string;
  [PaymentDetailsFieldName.isPayable]: boolean;
  [PaymentDetailsFieldName.payData]: AdditionalPayDataItem[];
};

export interface PaymentService {
  id: string;
  sub_name: string;
  code: string;
}
export interface PaymentServiceResponse {
  [key: string]: PaymentService[];
}

export interface PaymentServiceResponseOption extends SelectOption {
  data: PaymentServiceResponse[keyof PaymentServiceResponse];
}

export interface OrgNpuOption extends SelectOption {
  isPayable: boolean;
}

export type ResponsePaymentStatus = {
  status: InvoiceStatus;
};

export interface CreateInvoiceResponse {
  redirect_uri: string;
}

export interface PaymentInfoRequest {
  org_npu_id: string;
  drfo_code: string;
  defrayment_service_id: string;
}

export interface PaymentInvoiceRequest extends PaymentInfoRequest {
  full_name: string;
}

export interface PaymentReceipt {
  service_name: string;
  amount: number;
  status: UserRequestStatus;
  status_decorator: StatusDecorator;
  id: string;
  payed_at: string;
}
